import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { admin, soarAiRoutingModule } from '../soar-ai/soar-ai.routes';

export const soarAi: Routes = [
  { path: '', redirectTo: 'soar-ai', pathMatch: 'full' },
  {
    path: '',
    children: [
      ...soarAiRoutingModule.routes,
      
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class SoarAiRoutingModule {
  static routes = admin;
}